import { z } from "zod";
import { UpdateUserRequest } from "@/api/generated/client/models";

// 1. Define Validations (The Schema)
// We map this to UpdateUserRequest from the API
// Note: The "at least one field" validation is handled in the mutation function
// where we check if updateData has any keys after filtering unchanged values
export const updateUserSchema = z.object({
  email: z.string().email("Invalid email address").optional(),
  name: z.string().min(1, "Name is required").optional(),
  phone: z.string().nullish(),
  role: z.enum(['owner', 'admin', 'member'] as const).optional(),
  companyId: z.number().optional(),
  avatarUrl: z.string().url("Invalid avatar URL").nullish(),
});

// 2. Infer Types
export type UpdateUserForm = z.infer<typeof updateUserSchema>;

// 3. DRIFT PROTECTION
// Ensure our form stays compatible with Backend Types
// We check that our UpdateUserForm's fields match UpdateUserRequest
export type _BackendCheck = UpdateUserForm extends UpdateUserRequest ? true : false;
export type _BackendCheckReverse = UpdateUserRequest extends UpdateUserForm ? true : false;
